import React from 'react';

const SkeletonLoader = () => {
	return (
		<div className="skeleton">
			<div className="agenda-filter skeleton">
				<div className="agenda-filter__type">
					<button className="tag tag tag--orange skeleton__animation">
						Genre
					</button>
					<button className="tag tag tag--orange skeleton__animation">
						Datum
					</button>
					<button className="tag tag tag--orange skeleton__animation">
						Series
					</button>
				</div>
				<div class="agenda-filter__type"><button class="tag tag tag--orange skeleton__animation">Genre</button><button class="tag tag tag--orange skeleton__animation">Datum</button><button class="tag tag tag--orange skeleton__animation">Series</button><button class="tag tag tag--orange skeleton__animation">Series</button></div>
			</div>
			<ol className="stories skeleton animated-background">
				{Array.from({ length: 4 }).map((_, index) => (
					<li key={index} className="stories__item flow skeleton__placeholder">
						<div className="stories__img-container skeleton__animation">
							<div className="stories__img"></div>
						</div>
						<ul className="tag-list">
							<li className="skeleton__animation tag">tag</li>
							<li className="skeleton__animation tag">tag</li>
						</ul>
						<h3 className="h6 skeleton__animation stories__title ">Titel van een regel</h3>
						<p className="text-small skeleton__animation stories__text text-small skeleton__animation stories__text">Hier een tekst</p>
					</li>
				))}
			</ol>
		</div>
	);
};

export default SkeletonLoader;
